function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "location",
  transform: "translate(-774 -1155)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_12",
  "data-name": "Trazado 12",
  className: "cls-1",
  d: "M787.172,1161.586a6.586,6.586,0,0,0-13.172,0c0,4.391,6.586,12.075,6.586,12.075S787.172,1165.977,787.172,1161.586Zm-9.331,0a2.744,2.744,0,1,1,2.744,2.744A2.745,2.745,0,0,1,777.842,1161.586Z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_6",
  "data-name": "Rect\\xE1ngulo 6",
  className: "cls-1",
  width: 9,
  height: 2,
  transform: "translate(776 1174.954)"
}));

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.172,
    height: 21.954,
    viewBox: "0 0 13.172 21.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7959d865.svg";
export { ForwardRef as ReactComponent };